// Detects automated-test / CI runs so heavy, slow-to-load subsystems can be
// skipped to keep the Playwright suite fast and reliable. The motivating case:
// the Myra Gaussian-splat hair pulls a PLY + four ONNX nets and builds a
// SparkRenderer — slow enough to push the E2E gate past its budget and flake.
// In CI we skip it and let the avatar's polygonal hair show instead.
//
// (Originally authored by Shailesh on feature/gaussian-hair; the surviving
// consumers on main are Scene.jsx's GSSHairLocalMount and the OGS hair mount.)
//
// Two signals, both runtime (no Jenkins/env wiring required):
//   - navigator.webdriver — true under Playwright/Selenium automation, which
//     is exactly how the Jenkins E2E stage and `npm run test:e2e` drive the
//     app. This catches every CI run and every local test:e2e run.
//   - ?ci=1 URL param      — manual override for sharing a repro link or
//     eyeballing the CI behavior in a normal browser.
export function isCiMode() {
  if (typeof window === 'undefined') return false
  try {
    if (typeof navigator !== 'undefined' && navigator.webdriver) return true
    if (new URLSearchParams(window.location.search).get('ci') === '1') return true
  } catch {
    /* defensive: never let detection throw on the render path */
  }
  return false
}
